import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// redux
import { RootState } from 'store/ducks';
// services
import QuoteServices from 'services/quote.service';
import ProductServices from 'services/product.service';
import QuoteMapProductServices from 'services/quoteMapProduct.service';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import QuoteSentTimerLogServices from 'services/quoteSentTimerLog.service';
// axios
import { AxiosResponse } from 'axios';
// models
import { IProducts } from 'models/Product';
import { IBatchRequestResponse } from 'models/Batch';
import { modelPrioritizedItemsTable } from './models';
import { IQuoteSuggestion } from 'models/QuoteSuggestion';
import { IQuoteDetailItem } from 'models/QuoteDetailItem';
import { TimerOnMapProductProps } from 'models/QuoteSentTimerLog';
import { HistoryUsersUpdatedProps, IMapProductAddOrUpdateViewModel, IMapProductViewModel } from 'models/MapProduct';
// components
import Text from 'components/Text';
import { Visibility } from 'components/Visibility';
import Loader from '../components/generics/Loader';
import { toastify } from "components/Toastify/utils";
import { Row, Column } from 'components/Layout/Grid';
import ModalYesNo from '../components/generics/Modal/YesNo';
import RadioInput from '../components/generics/Input/Radio';
import ModalLoader from '../components/generics/Modal/Loader';
import { VisibilityConditional } from 'components/VisibilityConditional';
import PrioritizedItemsTable from 'pages/Quotes/components/generics/Tables/PrioritizedItems/PrioritizedItemsTable';
// mapping
import MappingHeader from './MappingHeader';
import AddSuggestions from './AddSuggestions';
// interfaces
import { CategoryType } from 'components/TabNavigation/interface';
import { QuotesMappingProps, typesMaterial, typesMedicice, typesNutrition } from './interface';
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//utils
import { colors } from '../styles/colors';
import { DateOutputStr } from 'utils/DateOutput';
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
// styles
import './styles.scss';
import { QuotationOrigin } from 'components/Table/interface';

const QuotesMapping = (props: QuotesMappingProps) => {
  const {
    detail,
    reloadTable,
    isMapProduct,
    onCloseAction,
    isNoSegmented,
    segmentSelected,
    enableButtonApproveSuggestions
  } = props;

  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const updateBudgetSaved = useSelector((state: RootState) => state.updateBudgetSaved);
  const { quoteDetail, quoteItem, setQuoteItem, sequence } = useDetailsQuoteContext();

  const [newForm, setNewForm] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [descriptionProduct, setDescriptionProduct] = useState('');
  const [codeProduct, setCodeProduct] = useState('');
  const [substanceProduct, setSubstanceProduct] = useState('');
  const [manufacturerProduct, setManufacturerProduct] = useState('');
  const [disableBtn, setDisableBtn] = useState<boolean>(true);
  const [tableOrderProduct, setTableOrderProduct] = useState('');
  const [listDnD, setListDnD] = useState<IQuoteSuggestion[]>([]);
  const [currentPageProduct, setCurrentPageProduct] = useState(0);
  const [allItensQuoteSegment, setAllItensQuoteSegment] = useState<any>();
  const [product, setProduct] = useState<IBatchRequestResponse<IProducts>>();
  const [quoteItemData, setQuoteItemData] = useState<Array<IQuoteDetailItem>>([]);
  const [quoteProduct, setQuoteProduct] = useState<IBatchRequestResponse<IQuoteSuggestion>>();
  const [batchResponse, setBatchResponse] = useState<{ data: Array<IQuoteDetailItem>; }>({ data: [] });
  const [, setNewProduct] = useState(false);
  const [reloadDetails, setReloadDetails] = useState(true);
  const [changeSuggestions, setChangeSuggestions] = useState(false);
  const [listSuggestion, setListSuggestion] = useState<Array<Object>>([]);
  const [shouldResetItem, setShouldResetItem] = useState<IQuoteDetailItem>({});
  const [addedMapProducts, setAddedMapProducts] = useState<Array<IMapProductViewModel>>([]);
  const [updatedMapProducts, setUpdatedMapProducts] = useState<Array<IMapProductViewModel>>([]);
  const [saveChange, setSaveChange] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [modalSave, setModalSave] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [endSecondRenderMapProduct, setEndSecondRenderMapProduct] = useState(false);
  const [removeProductResponse, setRemoveProdcutResponse] = useState('');
  const [lastUserEdit, setLastUserEdit] = useState<HistoryUsersUpdatedProps>();

  const bcgOnly = process.env.REACT_APP_BCG_ONLY === 'true';

  const pageSize = 500;
  const pageSizeProduct = 10;
  const timeout = useRef<any>();

  const _quoteServices = new QuoteServices();
  const _productServices = new ProductServices();
  const _quoteMapProductSevices = new QuoteMapProductServices();
  const _quoteSentTimerLogServices = new QuoteSentTimerLogServices();

  let saveNewProducts = false;
  let saveOrderResult = false;

  const itemMapProduct = allItensQuoteSegment?.data?.find((i: IQuoteDetailItem) => i?.sequenceNumber === props?.sequenceNumber);
  const itemSuggested = itemMapProduct?.productsSuggestion?.find((i: any) => i?.suggested || i?.sequentialSuggestion === "");
  const lastEditVisibility = listSuggestion !== undefined && listSuggestion.length > 0 && (!IsNullOrEmpty(itemSuggested?.historyUsersUpdated) || itemSuggested?.imported === true);

  const addedOrUpdatedMapProductList = (hospitalQuote: IQuoteDetailItem, mapProductAddOrUpdate: IMapProductAddOrUpdateViewModel, addedMapProducts?: IMapProductViewModel[], updatedMapProducts?: IMapProductViewModel[]) => {
    if (addedMapProducts && addedMapProducts.length > 0 && quoteItemData.length > 0) {
      addedMapProducts?.forEach(async (optionItem) => {
        const item: IMapProductViewModel = {
          quoteId: props.quoteId,
          sequenceNumber: props.sequenceNumber,
          hospitalDocumentNumber: hospitalQuote.buyerIdentifier!,
          supplierProductCode: optionItem.supplierProductCode,
          supplierProductDescription: optionItem?.supplierProductDescription,
          hospitalProductCode: hospitalQuote.code!,
          manufacturer: optionItem.manufacturer,
          sequentialSuggestion: String(listSuggestion.length++ + 1),
          barcode: optionItem.barcode,
          conversionFactor: optionItem.conversionFactor,
          id: undefined,
          productSegmentDescription: optionItem.productSegmentDescription,
          medicineTypeDescription: optionItem.medicineTypeDescription,
          substance: optionItem.substance,
          refrigeration: optionItem.refrigeration,
          competitorPrice: optionItem.competitorPrice,
          purchaseUnit: optionItem.purchaseUnit,
          historyUsersUpdated: optionItem.historyUsersUpdated
        };
        mapProductAddOrUpdate.addedMapProducts.push(item);
      });
    } else {
      saveNewProducts = true;
    }

    if (updatedMapProducts && updatedMapProducts.length > 0 && quoteItemData.length > 0) {
      updatedMapProducts?.forEach(async (optionItem) => {
        const item: IMapProductViewModel = {
          quoteId: props.quoteId,
          sequenceNumber: props.sequenceNumber,
          hospitalDocumentNumber: hospitalQuote.buyerIdentifier!,
          supplierProductCode: optionItem.supplierProductCode,
          supplierProductDescription: optionItem?.supplierProductDescription,
          hospitalProductCode: hospitalQuote.code!,
          manufacturer: optionItem.manufacturer,
          sequentialSuggestion: optionItem.sequentialSuggestion,
          barcode: optionItem.barcode,
          conversionFactor: optionItem.conversionFactor,
          id: optionItem.id,
          productSegmentDescription: optionItem.productSegmentDescription,
          medicineTypeDescription: optionItem.medicineTypeDescription,
          substance: optionItem.substance,
          refrigeration: optionItem.refrigeration,
          purchaseUnit: optionItem.purchaseUnit,
          historyUsersUpdated: optionItem.historyUsersUpdated
        };
        mapProductAddOrUpdate.updatedMapProducts.push(item);
      });

    } else {
      saveNewProducts = true;
    }
  };

  const handleCheckSuggestedItem = (result: AxiosResponse) => {
    const itemSuggested = result.data.data.find((item: any) => item.suggested);
    if (itemSuggested) {
      const _quoteItem = quoteItem?.data && quoteItem.data.find((item: IQuoteDetailItem) => item.sequenceNumber == props.sequenceNumber);
      const suggested = result.data.data.find((item: any) => item.suggested);

      if (_quoteItem && suggested) {
        setBatchResponse({
          data: [{
            ..._quoteItem, conversionAmount: getConversion(result.data.data, itemSuggested.id, false), productsSuggestion: _quoteItem.productsSuggestion && _quoteItem.productsSuggestion
              .map((suggestion: any) => ({ ...suggestion, suggested: suggestion.id == suggested.id, conversionFactor: getConversion(result.data.data, suggestion.id, true) }))
              .sort((a: any, b: any) =>
                result.data.data.findIndex((item: any) => item.id == a.id) -
                result.data.data.findIndex((item: any) => item.id == b.id)
              )
          }]
        });
      }
    }
    saveOrderResult = true;
  };

  const handleCheckNewForm = (result: AxiosResponse, isCloseModal?: boolean) => {
    if (!newForm) {
      if (changeSuggestions && updatedMapProducts) {
        if (result?.status !== 200) {
          setModalLoader(false);
        } else {
          handleCheckSuggestedItem(result);
          !isCloseModal && onCloseAction();
          dispatch({ type: "SHOW_TOASTIFY", data: { show: true } });
        }
        setModalLoader(false);
      } else if (result?.status === 200) {
        saveOrderResult = true;
        toastify.success("Novas sugestões foram salvas com sucesso");
      }
    } else {
      toastify.success("Novas sugestões foram salvas com sucesso");
    }
  };

  async function save(isCloseModal?: boolean) {
    if (listDnD.length > 0) {
      const blockedSaveFactorConversionNull = listDnD[0].conversionFactor;

      if (IsNullOrEmpty(blockedSaveFactorConversionNull)) {
        toastify.error("Não é possível salvar de/para com prioridade 1 sem fator de conversão");
        return;
      }
    }

    const hospitalQuote = quoteItemData[0];

    let mapProductAddOrUpdate: IMapProductAddOrUpdateViewModel = {
      quoteId: props.quoteId,
      sequenceBudget: sequence,
      sequenceNumber: props.sequenceNumber,
      hospitalDocumentNumber: hospitalQuote.buyerIdentifier!,
      hospitalProductCode: hospitalQuote.code!,
      addedMapProducts: new Array<IMapProductViewModel>(),
      updatedMapProducts: new Array<IMapProductViewModel>(),
      origin: quoteDetail?.origin?.toUpperCase() === "MVM" ? QuotationOrigin.MVM : QuotationOrigin.BIONEXO
    };

    addedOrUpdatedMapProductList(hospitalQuote, mapProductAddOrUpdate, addedMapProducts, updatedMapProducts);
    setModalLoader(true);
    const result = await _quoteMapProductSevices.saveMapProduct(mapProductAddOrUpdate);

    if (result.status !== 200) {
      setModalLoader(false);
      toastify.error("Não foi possível salvar novas sugestões");
    } else {
      if (!changeSuggestions && !updatedMapProducts)
        toastify.success("Novas sugestões foram salvas com sucesso");

      saveNewProducts = true;
      setNewProduct(false);
      setDisableBtn(true);
      setAddedMapProducts([]);
      setProduct(undefined);
      setDescriptionProduct('');
      setCodeProduct('');
      setManufacturerProduct('');
      setSubstanceProduct('');
      setBatchResponse(result.data);
      updateSuggestionList(result.data);
    }

    !isCloseModal && isMapProduct && updateListMapProduct(result.data);
    handleCheckNewForm(result, isCloseModal);

    if (saveOrderResult && saveNewProducts) {
      setChangeSuggestions(false);
      setDisableBtn(true);
    }
  }

  const refreshTableQuoteItems = (newOrderItems: IQuoteDetailItem[]) => {
    if (segmentSelected === CategoryType.MEDICINE) {
      return newOrderItems?.filter(x =>
        x.productsSuggestion && x.productsSuggestion.length > 0 &&
        typesMedicice.includes(x.productsSuggestion[0].productSegmentDescription.toUpperCase()));
    } else if (segmentSelected === CategoryType.MATERIAL) {
      return newOrderItems?.filter(x =>
        x.productsSuggestion && x.productsSuggestion.length > 0 &&
        typesMaterial.includes(x.productsSuggestion[0].productSegmentDescription.toUpperCase()));
    } else if (segmentSelected === CategoryType.NUTRITION) {
      return newOrderItems?.filter(x =>
        x.productsSuggestion && x.productsSuggestion.length > 0 &&
        typesNutrition.includes(x.productsSuggestion[0].productSegmentDescription.toUpperCase()));
    } else if (segmentSelected === CategoryType.DEFAULT) {
      return newOrderItems?.filter(x => x.productsSuggestion && x.productsSuggestion.length === 0);
    }

    return [];
  };

  const getConversionAmount = (quantity: number, conversionFactor: number, multiple: number) => {
    let value = Math.floor(quantity / conversionFactor);
    if (value < multiple)
      value = multiple;
    else {
      let modMultiple = value % multiple;
      if (modMultiple > 0)
        value -= modMultiple;
    }
    return value;
  };

  useEffect(() => {
    if (quoteItem && reloadDetails) {
      setAllItensQuoteSegment(quoteItem);
      setReloadDetails(false);
    }
  }, [reloadDetails, quoteItem]);

  const renderItemsMap = (itemMapProductParam?: AxiosResponse<any>) => {
    const result: any = {};
    const response = itemMapProductParam ?? itemMapProduct;

    if (allItensQuoteSegment?.data) {
      const { error, total } = result;
      const dataMapping = Array<IQuoteDetailItem>();
      const suggestionMapping = Array<IQuoteSuggestion>();

      allItensQuoteSegment?.data.forEach((quote: any) => {
        const renderMapProducts = !quote?.budgets || quote?.budgets?.sequence === 0 || (quote?.budgets?.sequence === 1 && quote?.budgets?.sent) || (quote?.budgets && !quote?.budgets?.sequence);
        if (Number(props.sequenceNumber) === quote?.sequenceNumber && props.quoteId === quote?.quoteId && (renderMapProducts)) {
          dataMapping.push({
            isCustomer: true,
            sequenceNumber: quote.sequenceNumber,
            id: quote.id,
            supplierProductCode: quote.productCode,
            code: quote.productCode,
            rentability: quote.rentability,
            description: quote.description,
            quantity: quote.quantity,
            totalItens: quote.totalItens,
            unit: quote.unit,
            weight: quote.weight,
            brand: quote.brand,
            producer: quote.producer ?? quote.manufacturer,
            stock: quote.stock,
            imported: quote.imported,
            productOutOfPortfolio: quote.productOutOfPortfolio,
            buyerIdentifier: quote.buyerIdentifier,
            subUnitValue: quote.subUnitValue
          } as IQuoteDetailItem);

          if (quote.productsSuggestion && quote.productsSuggestion.length > 0) {
            if (response && !response.status) {
              itemMapProduct.productsSuggestion?.forEach((suggestion: any) => {
                suggestionMapping.push(getItem(quote, suggestion));
              });
            } else {
              if (response && response.status !== 200) {
                toastify.error("Falha ao carregar dados do Money");
                quote.productsSuggestion?.forEach((suggestion: any) => {
                  suggestionMapping.push(getItem(quote, suggestion));
                });
              } else {
                response?.data.data[0].productsSuggestion?.forEach((suggestion: any) => {
                  suggestionMapping.push(getItem(quote, suggestion));
                });

                quote.productsSuggestion = suggestionMapping;
              }
            }

            setNewForm(false);
          } else {
            setNewForm(true);
          }
        }
      });

      if (!isMapProduct && itemMapProductParam)
        setQuoteItem(allItensQuoteSegment);

      setQuoteItemData(dataMapping);

      setQuoteProduct({
        error,
        data: suggestionMapping,
        totalPages: 1,
        pageSize: 200,
        total,
      });
    }
  };

  const detailsItem = async (useMoney: boolean) => {
    const response = await _quoteServices.quoteSuggestionDetailItem(
      props.quoteId,
      "",
      0,
      true,
      useMoney,
      1,
      props.sequenceNumber
    );

    if (useMoney)
      setEndSecondRenderMapProduct(true);

    renderItemsMap(response);
  };

  const getQuotesSolicitation = () => {
    renderItemsMap();
    setEndSecondRenderMapProduct(true);
  };

  function getItem(quote: any, suggestion: any) {
    return {
      isCustomer: false,
      sequenceNumber: quote.sequenceNumber,
      id: suggestion.id,
      conversionAmount: quote.conversionAmount,
      supplierProductcode: suggestion.supplierProductcode,
      supplierProductCodeRA: suggestion.supplierProductCodeRA,
      code: suggestion.supplierProductcode,
      description: suggestion.description ?? suggestion.supplierProductDescription,
      quantity: suggestion.quantity,
      totalItens: quote.totalItens,
      hasCommercialCost: quote.hasCommercialCost,
      unitPrice: quote.unitPrice,
      unit: suggestion.purchaseUnit ?? suggestion.unit,
      subUnit: suggestion.subUnit,
      subUnitValue: suggestion.subUnitValue,
      rentability: quote.rentability,
      conversionFactor: suggestion.conversionFactor === 0 ? '' : suggestion.conversionFactor,
      multiple: suggestion.multiple || 1,
      manufacturer: suggestion.manufacturer ?? suggestion.producer,
      medicineTypeDescription: suggestion.medicineTypeDescription,
      productSegmentDescription: suggestion.productSegmentDescription,
      stock: suggestion.stock,
      delete: '',
      suggested: suggestion.suggested,
      imported: suggestion.imported,
      itemBatch: suggestion.itemBatch,
      itemStock: suggestion.itemStock,
      substance: suggestion.substance,
      refrigeration: suggestion.refrigeration,
      sequentialSuggestion: suggestion.sequentialSuggestion,
      useMoney: true,
      createdDate: suggestion.createdDate,
      historyUsersUpdated: suggestion.historyUsersUpdated,
      isApproved: suggestion.isApproved,
      isCreatedAutomatically: suggestion.isCreatedAutomatically,
      typeMapCreated: suggestion.typeMapCreated,

    } as IQuoteSuggestion;
  }

  const handleSetProduct = (result: any) => {
    if (result?.data) {
      const { error, data, totalPages, pageSize, total } = result;

      data?.forEach((product: any) => {
        product.suggested = false;
      });

      setProduct({
        error,
        data,
        totalPages,
        pageSize,
        total,
      });
      if (result?.data < 1) {
        setNotFound(true);
      } else {
        setNotFound(false);
      }
    }
  };

  const getProduct = async (
    descriptionProduct: string,
    codeProduct: string,
    manufacturerProduct: string,
    substanceProduct: string,
    resetCurrentPage?: boolean) => {
    KeycloakPubServiceInstance.subscribe(async () => {
      setProduct(undefined);

      const name = descriptionProduct.toLowerCase();
      const code = codeProduct.toLowerCase();
      const productBrand = manufacturerProduct.toLowerCase();
      const substance = substanceProduct.toLowerCase();

      if (name && name.length > 0 ||
        code && code.length > 0 ||
        productBrand && productBrand.length > 0 ||
        substance && substance.length > 0
      ) {
        if (resetCurrentPage) {
          setCurrentPageProduct(0);
        }

        const result = await _productServices.getProductsWithBlockedItems(
          productBrand,
          substance,
          name,
          code,
          currentPageProduct,
          pageSizeProduct,
          tableOrderProduct
        );

        handleSetProduct(result);
      } else {
        setProduct({
          error: false,
          data: [],
          totalPages: 0,
          pageSize,
          total: 0,
        });
      }
    });
  };

  function handleMedicineTypeDescription(medicineType: string) {
    if (medicineType && medicineType === 'Etico ou de Marca') {
      return 'Ético/Marca';
    } else if (medicineType && medicineType === 'Generico') {
      return 'genérico';
    } else {
      return medicineType;
    }
  }

  const notifyDetails = useCallback((dataSuggestion: IQuoteDetailItem) => {
    let multipleItensNotSent;
    const multipleItens = quoteItem?.data?.filter(x => x.sequenceNumber === props.sequenceNumber) ?? [];

    if (multipleItens.length > 1) {
      multipleItensNotSent = multipleItens.map(m => ({ ...m, productsSuggestion: dataSuggestion.productsSuggestion }));
    }

    const suggestedItem = !multipleItensNotSent && dataSuggestion.productsSuggestion?.find(s => s.suggested);
    const filterNewOrderItems = (quoteItem!.data! && multipleItensNotSent ?
      [...quoteItem!.data!.filter((s: IQuoteDetailItem) => s.sequenceNumber != props.sequenceNumber), multipleItensNotSent[0], multipleItensNotSent[1]] :
      [...quoteItem!.data!.filter((s: IQuoteDetailItem) => s.sequenceNumber != props.sequenceNumber), dataSuggestion]
    );

    const verifyPriorityBCG = filterNewOrderItems?.filter((item: any) => item.priorityBCG?.ranking > 0);
    if ((bcgOnly || user?.isBCGUser) && verifyPriorityBCG.length > 0)
      filterNewOrderItems.sort((a: any, b: any) =>
        (a.priorityBCG?.displayed - b.priorityBCG?.displayed) ||
        (a.priorityBCG?.ranking - b.priorityBCG?.ranking) ||
        (a.sequenceNumber - b.sequenceNumber)
      );
    else
      filterNewOrderItems.sort((a: any, b: any) => a.sequenceNumber - b.sequenceNumber);

    let newQuotesFiltered: IQuoteDetailItem[] = filterNewOrderItems!;

    if ((suggestedItem && (quoteItemData.length > 1 && quoteItemData[1]?.id != suggestedItem.id)) || (!suggestedItem && dataSuggestion.productsSuggestion && dataSuggestion.productsSuggestion?.length > 0 && !multipleItensNotSent)) {
      setShouldResetItem(dataSuggestion);
    } else if (segmentSelected && reloadTable && !isNoSegmented && !multipleItensNotSent) {
      //alterar os itens originais com a nova ordem de prioridade
      setAllItensQuoteSegment({
        ...allItensQuoteSegment,
        data: filterNewOrderItems
      });

      newQuotesFiltered = refreshTableQuoteItems(newQuotesFiltered);

      if (!isMapProduct) {
        setQuoteItem({
          ...quoteItem!,
          data: newQuotesFiltered
        });

        reloadTable(props.quoteId);
      }
    } else {
      setAllItensQuoteSegment({
        ...allItensQuoteSegment,
        data: filterNewOrderItems
      });

      if (!isMapProduct) {
        setQuoteItem({
          ...quoteItem!,
          data: newQuotesFiltered
        });

        reloadTable && reloadTable(props.quoteId);
      }
    }

    setModalLoader(false);
  }, [quoteItem, props.sequenceNumber, quoteItemData]);

  const reorderItems = (itemsReorder: IQuoteDetailItem) => {
    const suggested = itemsReorder?.productsSuggestion?.find(s => s.suggested);
    let index = suggested && itemsReorder.productsSuggestion?.indexOf(suggested);

    if ((typeof index == "number" && index < 0) || !index) {
      index = 0;
      if (itemsReorder.productsSuggestion && itemsReorder.productsSuggestion.length > 0)
        itemsReorder.productsSuggestion[index].suggested = true;
    }

    if (typeof index == "number" && itemsReorder.productsSuggestion && itemsReorder.productsSuggestion.length > 0) {
      itemsReorder.isValid = false;
      itemsReorder.productsSuggestion[index].rentability = 5;
      itemsReorder.productsSuggestion[index].conversionAmount =
        itemsReorder?.productsSuggestion[index]?.conversionFactor! > 0 ?
          getConversionAmount(itemsReorder.productsSuggestion[index].quantity,
            itemsReorder.productsSuggestion[index].conversionFactor!,
            itemsReorder.productsSuggestion[index].multiple) : 0;
    }
  };

  const updateListMapProduct = useCallback((listItemUpdate?: { data: IQuoteDetailItem[]; }) => {
    if ((batchResponse.data.length > 0 || listItemUpdate?.data?.length) && isMapProduct) {
      const list = listItemUpdate ?? batchResponse;
      const indexItem = quoteItem!.data && quoteItem!.data.findIndex((itemDelete: IQuoteDetailItem) => itemDelete.quoteId === props.quoteId && Number(itemDelete.sequenceNumber) === Number(props.sequenceNumber));
      const suggestionList: IQuoteDetailItem = list.data[0];
      const itemUpdated = quoteItem!.data![indexItem!];
      const totalIndexUpdate: number[] = [];
      reorderItems(suggestionList);

      quoteItem!.data!.map((item: IQuoteDetailItem, index: number) => {
        if (totalIndexUpdate.length === 0)
          totalIndexUpdate.push(indexItem!);
        else if (item?.company?.crmCustomerCode === itemUpdated?.company?.crmCustomerCode && item.productCode === itemUpdated.productCode && !totalIndexUpdate.includes(index))
          totalIndexUpdate.push(index);
      });

      for (let indexUpdate of totalIndexUpdate)
        quoteItem!.data![indexUpdate].productsSuggestion = suggestionList.productsSuggestion;

      setQuoteItem({
        ...quoteItem!,
        data: quoteItem?.data
      });
    }
  }, [batchResponse]);

  const updateSuggestionList = (result?: any) => {
    if (batchResponse?.data.length > 0 || result?.data.length > 0)
      notifyDetails(result?.data[0] || batchResponse.data[0]);
  };

  function toggleSuggestProduct(suggestion: any, toggle: any) {
    const indexSequence = quoteItem!.data!.findIndex((itemDelete: IQuoteDetailItem) => itemDelete.quoteId === props.quoteId && Number(itemDelete.sequenceNumber) === Number(props.sequenceNumber));
    const lastSequence = Number(quoteItem!.data![indexSequence].sequentialSuggestion);

    const item: IMapProductViewModel = {
      supplierProductCode: suggestion.code,
      quoteId: "",
      sequenceNumber: props.sequenceNumber,
      hospitalDocumentNumber: "",
      hospitalProductCode: "",
      supplierProductDescription: suggestion.name,
      manufacturer: suggestion.productBrand,
      sequentialSuggestion: String(lastSequence + 1),
      barcode: suggestion.barcode,
      productSegmentDescription: suggestion.productSegment,
      medicineTypeDescription: handleMedicineTypeDescription(suggestion.medicineType),
      substance: suggestion.substance,
      refrigeration: suggestion.refrigeration,
      purchaseUnit: suggestion.firstUnit,
      historyUsersUpdated: suggestion.historyUsersUpdated
    };

    if (toggle.checked === true) {
      addedMapProducts.push(item);
    } else {
      addedMapProducts?.forEach((optionItem, index, object) => {
        if (optionItem.supplierProductCode === suggestion.code) {
          object.splice(index, 1);
        }
      });
    }

    if (addedMapProducts.length > 0) {
      setNewProduct(true);
    } else {
      setNewProduct(false);
    }

    const newMapProducts = addedMapProducts;
    setAddedMapProducts(newMapProducts);
  }

  function checkIsSelected(dataId: string) {
    let hasCheck = false;
    addedMapProducts?.forEach((optionItem) => {
      if (optionItem.supplierProductCode === dataId) {
        hasCheck = true;
      }
    });
    return hasCheck;
  }

  const getConversion = (listResponse: any[], id: string, isFactor: boolean) => {
    const item = listResponse.find((item: any) => item.id == id);
    return isFactor ? (item?.conversionFactor) : item?.conversionAmount;
  };

  const existsMapProduct = itemMapProduct ? itemMapProduct?.productsSuggestion?.length > 0 : quoteItemData;

  useEffect(() => {
    if (props.quoteId && props.sequenceNumber && quoteItem && allItensQuoteSegment) {
      if (((itemMapProduct?.productsSuggestion?.length > 0 && itemMapProduct?.productsSuggestion?.length <= 2) && !endSecondRenderMapProduct) || isMapProduct)
        Promise.all([detailsItem(false), detailsItem(true)]);
      else
        getQuotesSolicitation();
    }
  }, [props.quoteId, quoteItem, allItensQuoteSegment]);

  useEffect(() => {
    const listID: any = listSuggestion?.map((list: any, index: number) => {
      let value;
      let counter = 1;
      const { conversionFactor } = list;

      if (typeof conversionFactor === 'string') {
        value = Number(conversionFactor?.replace(/,/, '.'));
      } else {
        value = conversionFactor;
      }

      return {
        id: list.id,
        quantity: list.quantity,
        manufacturer: list.manufacturer,
        productSegmentDescription: list.productSegmentDescription,
        medicineTypeDescription: list.medicineTypeDescription,
        multiple: list.multiple,
        conversionFactor: !list.conversionFactor || list.conversionFactor <= 0 ? null : value,
        suggested: list.suggested,
        sequentialSuggestion: index + counter,
        supplierProductCode: list.supplierProductcode,
        supplierProductCodeRA: list.supplierProductCodeRA,
        supplierProductDescription: list.description,
        substance: list.substance,
        refrigeration: list.refrigeration,
        purchaseUnit: list.unit,
        historyUsersUpdated: list.historyUsersUpdated,
        isApproved: list.isApproved,
        isCreatedAutomatically: list.isCreatedAutomatically,
        typeMapCreated: list.typeMapCreated
      };

    });

    setUpdatedMapProducts(listID);

  }, [listSuggestion]);

  useEffect(() => {
    if (enableButtonApproveSuggestions) return setDisableBtn(false);

    setDisableBtn(!changeSuggestions);
  }, [changeSuggestions]);

  useEffect(() => {
    updateSuggestionList();
  }, [batchResponse]);

  const newQuotesList = () => {
    const filterNewOrderItems = quoteItem! && [...quoteItem!.data!.filter((s: IQuoteDetailItem) => s.sequenceNumber != shouldResetItem.sequenceNumber), shouldResetItem];

    if (bcgOnly || user?.isBCGUser)
      filterNewOrderItems.sort((a: any, b: any) =>
        (b.priorityBCG?.displayed - a.priorityBCG?.displayed) ||
        (a.priorityBCG?.ranking - b.priorityBCG?.ranking)
      );
    else
      filterNewOrderItems.sort((a: any, b: any) => a.sequenceNumber - b.sequenceNumber);

    setAllItensQuoteSegment({
      ...allItensQuoteSegment,
      data: filterNewOrderItems
    });

    let newQuotesFiltered: IQuoteDetailItem[] = filterNewOrderItems!;

    if (segmentSelected && !isNoSegmented) {
      newQuotesFiltered = refreshTableQuoteItems(newQuotesFiltered);
    }

    if (!isMapProduct) {
      reloadTable && reloadTable(props.quoteId);

      setQuoteItem({
        ...quoteItem!,
        data: newQuotesFiltered
      });
      dispatch({ type: 'SET_NEW_BUDGET_SAVED', data: { isUpdate: !updateBudgetSaved?.isUpdate } });
      dispatch({ type: 'SET_RESET_BUDGET', data: { isReset: true, productCode: quoteItemData[0].supplierProductCode } });
    }
  };

  useEffect(() => {
    if (shouldResetItem?.id) {
      _quoteServices.resetBuget({
        quoteId: props.quoteId,
        sequenceNumber: props.sequenceNumber,
        sequenceBudget: 0,
      }).then(() => {
        if (!isMapProduct) {
          reorderItems(shouldResetItem);
        }

        newQuotesList();
      });

      setShouldResetItem({});
    }
  }, [shouldResetItem]);

  useEffect(() => {
    if (modalSave && saveChange !== '') {
      if (saveChange === 'yes') {
        onCloseAction();
      }
      setModalSave(false);
      setSaveChange('');
    }
  }, [saveChange]);

  useEffect(() => {
    getProduct(descriptionProduct, codeProduct, manufacturerProduct, substanceProduct);
  }, [currentPageProduct, tableOrderProduct]);

  const setTimerOnQuotation = async (isEnd: boolean) => {
    const timerMapProduct: TimerOnMapProductProps = {
      quoteId: props.quoteId,
      sequenceNumber: Number(props.sequenceNumber),
      isEnd
    };

    await _quoteSentTimerLogServices.TimerOnMapProduct(timerMapProduct);
  };

  useEffect(() => {
    if (!isMapProduct) {
      if (props.quoteId)
        setTimerOnQuotation(false);

      return () => {
        setTimerOnQuotation(true);
      };
    }
  }, [props.quoteId]);

  const orderArrayDate = (items: IQuoteSuggestion[]) => {
    items.sort(function (a, b) {
      const dateA = new Date(a.historyUsersUpdated![0].date);
      const dateB = new Date(b.historyUsersUpdated![0].date);

      if (dateA < dateB) {
        return -1;
      } else if (dateA > dateB) {
        return 1;
      } else {
        return 0;
      }
    });

    const item = items[items.length - 1];
    const history = item.historyUsersUpdated![item.historyUsersUpdated!.length - 1];
    return history;
  };

  useEffect(() => {
    if (quoteProduct?.data) {
      const maps = quoteProduct.data.filter(x => x.sequenceNumber === props.sequenceNumber && x.historyUsersUpdated && x.historyUsersUpdated.length > 0);

      if (maps.length > 0) {
        const map = orderArrayDate(maps);

        if (!IsNullOrEmpty(map.date) && !IsNullOrEmpty(map.name)) {
          setLastUserEdit({
            name: map.name,
            date: map.date
          });
        }
      }
    }
  }, [quoteProduct?.data]);

  const lastEdit = () => (
    <Text className="title-section ml-2" color={colors.gray1} size={12}>
      {`(Última edição: ${lastUserEdit?.name} em ${DateOutputStr(lastUserEdit?.date, "dd/MM/yyyy 'às' HH:mm")})`}
    </Text>
  );

  const upload = () => (
    <Text className="title-section ml-2" color={colors.gray1} size={12}>
      {`(De/para criado via upload em  ${DateOutputStr(itemMapProduct?.productsSuggestion[0]?.createdDate, "dd/MM/yyyy 'às' HH:mm")})`}
    </Text>
  );

  return (
    <>
      <MappingHeader
        save={save}
        detail={detail}
        disableBtn={disableBtn}
        setModalSave={setModalSave}
        isMapProduct={isMapProduct}
        onCloseAction={onCloseAction}
        updateListMapProduct={updateListMapProduct}
        quoteItemData={itemMapProduct ?? quoteItemData[0]}
        endSecondRenderMapProduct={endSecondRenderMapProduct}
      />
      <div className='mapping-content'>
        <AddSuggestions
          save={save}
          product={product}
          timeOut={timeout}
          notFound={notFound}
          setProduct={setProduct}
          getProduct={getProduct}
          codeProduct={codeProduct}
          setNotFound={setNotFound}
          quoteProduct={quoteProduct}
          setNewProduct={setNewProduct}
          setCodeProduct={setCodeProduct}
          checkIsSelected={checkIsSelected}
          substanceProduct={substanceProduct}
          addedMapProducts={addedMapProducts}
          tableOrderProduct={tableOrderProduct}
          descriptionProduct={descriptionProduct}
          currentPageProduct={currentPageProduct}
          manufacturerProduct={manufacturerProduct}
          setAddedMapProducts={setAddedMapProducts}
          setSubstanceProduct={setSubstanceProduct}
          toggleSuggestProduct={toggleSuggestProduct}
          setTableOrderProduct={setTableOrderProduct}
          setDescriptionProduct={setDescriptionProduct}
          setCurrentPageProduct={setCurrentPageProduct}
          setManufacturerProduct={setManufacturerProduct}
          listSuggestion={!newForm ? listSuggestion : [{}]}
          endSecondRenderMapProduct={endSecondRenderMapProduct}
        />
        <Column className="w-50 w-sm-100">
        </Column>
        <Visibility visible={!newForm}>
          <Row className="mt-5 mb-1">
            <Text className="title-section color-primaryViveo font-bold" size={12}>
              Itens Deparados
            </Text>
            <Visibility visible={lastEditVisibility}>
              <VisibilityConditional
                condition={!IsNullOrEmpty(lastUserEdit)}
                firstOption={() => lastEdit()}
                secondOption={() => upload()}
              />
            </Visibility>
          </Row>
          {quoteProduct?.data !== undefined && quoteProduct?.data.length > 0 &&
            <PrioritizedItemsTable
              listDnD={listDnD}
              quoteId={props.quoteId}
              setListDnD={setListDnD}
              list={quoteProduct?.data}
              setOpenModal={setOpenModal}
              setModalLoader={setModalLoader}
              setBatchResponse={setBatchResponse}
              setListSuggestion={setListSuggestion}
              modalResponse={removeProductResponse}
              headerLabels={modelPrioritizedItemsTable}
              cCliente={quoteDetail?.customerCode ?? ''}
              setChangeSuggestions={setChangeSuggestions}
              itemSelected={itemMapProduct ?? quoteItemData[0]}
              endSecondRenderMapProduct={endSecondRenderMapProduct}
              quoteItem={allItensQuoteSegment?.data && allItensQuoteSegment?.data.find((item: IQuoteDetailItem) => item.sequenceNumber == props.sequenceNumber)}
            />
          }

          <Visibility visible={quoteProduct?.data === undefined}>
            <Row className="justify-center">
              <Loader size={45} />
            </Row>
          </Visibility>
        </Visibility>
        <Visibility visible={!existsMapProduct}>
          <Text className="text-center color-blue-gray mt-20" size={16}>
            Ainda não há itens deparados para esse produto. <br />
            Utilize a barra de busca para criar o primeiro de/para.
          </Text>
        </Visibility>
        <Visibility visible={openModal}>
          <ModalYesNo
            text={
              "O produto será retirado da lista de sugestões de DE/PARA.\nDeseja continuar?"
            }
            setModalResponse={setRemoveProdcutResponse}
          />
        </Visibility>
        <Visibility visible={modalSave}>
          <ModalYesNo
            text="As alterações desse item não foram salvas. Deseja continuar?"
            setModalResponse={setSaveChange}
          />
        </Visibility>
        <Visibility visible={modalLoader}><ModalLoader /></Visibility>
      </div>
    </>
  );
};

export default QuotesMapping;